var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "sap-status-matrix",
      attrs: { role: "table", "aria-label": "SAP portal status" },
    },
    [
      _c(
        "div",
        { staticClass: "sap-status-matrix__header", attrs: { role: "row" } },
        [
          _c(
            "div",
            {
              staticClass: "sap-status-matrix__corner",
              attrs: { role: "columnheader" },
            },
            [
              _c("div", { staticClass: "sap-status-matrix__title" }, [
                _vm._v("CASS Health"),
              ]),
              _c("div", { staticClass: "sap-status-matrix__countdown" }, [
                _vm._v(_vm._s(_vm.countdown)),
              ]),
            ]
          ),
          _vm._l(_vm.environments, function (environment) {
            return _c(
              "div",
              {
                key: environment,
                staticClass: "sap-status-matrix__environment",
                attrs: { role: "columnheader" },
              },
              [
                _c(
                  "v-chip",
                  {
                    attrs: {
                      small: "",
                      color: _vm.environmentColor(environment),
                      dark: "",
                    },
                  },
                  [_vm._v(" " + _vm._s(environment) + " ")]
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._l(_vm.rows, function (row) {
        return _c(
          "div",
          {
            key: row.portal,
            staticClass: "sap-status-matrix__row",
            attrs: { role: "row" },
          },
          [
            _c(
              "div",
              {
                staticClass: "sap-status-matrix__portal",
                attrs: { role: "rowheader" },
              },
              [_vm._v(" " + _vm._s(row.label) + " ")]
            ),
            _vm._l(_vm.environments, function (environment) {
              return _c(
                "div",
                {
                  key: environment,
                  staticClass: "sap-status-matrix__cell",
                  attrs: { role: "cell" },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "sap-status-matrix__link",
                      attrs: {
                        href: _vm.portalUrl(environment, row.portal),
                        target: "_blank",
                        rel: "noopener noreferrer",
                        title: `Open ${row.label} for ${environment}`,
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          class: _vm.statusTextClass(
                            _vm.portalStatus(environment, row.portal).status
                          ),
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.portalStatus(environment, row.portal).status
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            }),
          ],
          2
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }